const WEB3FORMS_ENDPOINT = 'https://api.web3forms.com/submit';
const WEB3FORMS_ACCESS_KEY = process.env.NEXT_PUBLIC_WEB3FORMS_ACCESS_KEY;
const SITE_ORIGIN = 'https://www.viventium.ai';

type Web3FormsLead = {
  formName: string;
  subject: string;
  fields: Record<string, string | undefined>;
};

export function hasBrowserWeb3Forms(): boolean {
  return Boolean(WEB3FORMS_ACCESS_KEY);
}

export async function submitBrowserWeb3FormsLead({
  formName,
  subject,
  fields
}: Web3FormsLead): Promise<void> {
  if (!WEB3FORMS_ACCESS_KEY) {
    throw new Error('Missing NEXT_PUBLIC_WEB3FORMS_ACCESS_KEY');
  }

  const payload = new FormData();
  payload.set('access_key', WEB3FORMS_ACCESS_KEY);
  payload.set('subject', subject);
  payload.set('from_name', 'Viventium Website');
  payload.set('form_name', formName);
  payload.set('source_url', fields.source_url ?? SITE_ORIGIN);

  Object.entries(fields).forEach(([key, value]) => {
    if (value !== undefined && value.trim() !== '') {
      payload.set(key, value.trim());
    }
  });

  const response = await fetch(WEB3FORMS_ENDPOINT, {
    method: 'POST',
    headers: {
      Accept: 'application/json'
    },
    body: payload
  });

  const result = (await response.json().catch(() => ({}))) as {
    success?: boolean;
    message?: string;
  };

  if (!response.ok || result.success === false) {
    throw new Error(result.message ?? 'Web3Forms rejected the lead');
  }
}
